import { render, staticRenderFns } from "./CalendarWidgetSettings.vue?vue&type=template&id=4f87e2d4"
import script from "./CalendarWidgetSettings.vue?vue&type=script&lang=ts"
export * from "./CalendarWidgetSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f87e2d4')) {
      api.createRecord('4f87e2d4', component.options)
    } else {
      api.reload('4f87e2d4', component.options)
    }
    module.hot.accept("./CalendarWidgetSettings.vue?vue&type=template&id=4f87e2d4", function () {
      api.rerender('4f87e2d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/CalendarWidgetSettings.vue"
export default component.exports